import baseUnifiApi from "./BaseUnifiApi";

export function updateSplashTimeout(data) {
  return baseUnifiApi.request({
    url: "/update-splash-timeout/",
    method: "PUT",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}